import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Button, DisplayText } from '@garnish/core';
import { Image } from '@garnish/media';

import { useContactUsHandler } from '@order/shared-hooks';

export const UnavailableReceiptView = (props: UnavailableReceiptViewProps) => {
  const { title, description, shouldDisplayContactUs = false } = props;

  const { handleContactUs } = useContactUsHandler('receipt');

  return (
    <View style={styles.wrapper}>
      <Image source={require('./assets/reward-card.png')} style={styles.img} contentFit="contain" />

      <DisplayText
        sizeMatch={['24', '32', '40', '40']}
        style={styles.heading}
        accessibilityRole="header"
        {...{ accessibilityLevel: 1 }}
      >
        {title}
      </DisplayText>

      <BodyText sizeMatch={['16']} style={styles.description}>
        {description}
      </BodyText>

      {shouldDisplayContactUs ? (
        <View style={styles.btnContainer}>
          <Button style={styles.btn} palette="primary" size="large" onPress={handleContactUs}>
            <FormattedMessage {...messages.contactUsCta} />
          </Button>
        </View>
      ) : null}
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  contactUsCta: {
    defaultMessage: 'Contact us',
    description: 'Receipt | Unavailable View | CTA | Contact us',
  },
});

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    paddingVertical: theme.spacing['10'],
    paddingHorizontal: theme.spacing['6'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  heading: {
    marginVertical: theme.spacing['4'],
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
  },
  img: {
    width: 200,
    height: 200,
  },
  btnContainer: {
    paddingTop: theme.spacing['10'],
  },
  btn: {
    minWidth: 193,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type UnavailableReceiptViewProps = {
  title: string;
  description?: string;
  shouldDisplayContactUs?: boolean;
};
